/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateModelDto
 */
export interface CreateModelDto {
    /**
     * モデル名
     * @type {string}
     * @memberof CreateModelDto
     */
    name: string;
    /**
     * 説明
     * @type {string}
     * @memberof CreateModelDto
     */
    description?: string;
    /**
     * ワークフロー定義
     * @type {object}
     * @memberof CreateModelDto
     */
    definition: object;
    /**
     * データスキーマ
     * @type {object}
     * @memberof CreateModelDto
     */
    dataSchema: object;
    /**
     * データアクセスポリシー
     * @type {object}
     * @memberof CreateModelDto
     */
    policy: object;
}

/**
 * Check if a given object implements the CreateModelDto interface.
 */
export function instanceOfCreateModelDto(value: object): value is CreateModelDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('definition' in value) || value['definition'] === undefined) return false;
    if (!('dataSchema' in value) || value['dataSchema'] === undefined) return false;
    if (!('policy' in value) || value['policy'] === undefined) return false;
    return true;
}

export function CreateModelDtoFromJSON(json: any): CreateModelDto {
    return CreateModelDtoFromJSONTyped(json, false);
}

export function CreateModelDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateModelDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'definition': json['definition'],
        'dataSchema': json['dataSchema'],
        'policy': json['policy'],
    };
}

export function CreateModelDtoToJSON(json: any): CreateModelDto {
    return CreateModelDtoToJSONTyped(json, false);
}

export function CreateModelDtoToJSONTyped(value?: CreateModelDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'definition': value['definition'],
        'dataSchema': value['dataSchema'],
        'policy': value['policy'],
    };
}

